<script>
    import Card from './Card.svelte';
    import Preview from './Preview.svelte';
    import FullPage from './FullPage.svelte';
    import ModalButton from './ModalButton.svelte';
    import Modal from './Modal.svelte';
    import PlayerView from './PlayerView.svelte';
    import TokenEdit from './TokenEdit.svelte';
    import TokenDisplay from './TokenDisplay.svelte';
    import LogItem from './LogItem.svelte';
    import Log from './Log.svelte';
    import LogCard from './LogCard.svelte';
    import Track from './Track.svelte';
    import DeckLook from './DeckLook.svelte';
    import Prompt from './Prompt.svelte';
    import PhoneGame from './mobile/PhoneGame.svelte';
    import { phoneLayout, hideOnPhone } from './mobile/layout.js';
    import { draggable } from 'svelte-drag';
    import { clone, state, ui, res, prefs, live } from './stores.js';
    import { setUp, moveTo, doAction, getLogForTurn, undo, handSize, replayPrev, replayNext, getCard, isBadlands } from './game.js';
    import { setupShortcuts } from './shortcuts.js';
    import { changeView, changeSeat, pause, advance, convert, formatBytes, info, choose, isTouchDevice, catchupOneStep, catchupFully, activePlayer, currentPlayer, hasLogText } from './ui.js';
    import { blur, fade } from 'svelte/transition';
    import { tick } from 'svelte/internal';
    import { takeTurns } from './turns.js';
    import { scoreGame } from './scores.js'
    import { getHints, autoActionButton } from './parse.js';
    import { isMe, numMultiPlayers } from './net.js'
    import { shuffle, getDeck, updateState } from './game.js';
    import { look, stardateGlory, lookAtCards, closeLook, playerResourceTypes, sdCards, stardateSummary, editStardate } from './card_actions.js';
    import { afterUpdate, onDestroy, onMount } from 'svelte';
    import { costAdjustments, canAdjustCost, adjustCost, renderCost } from './costs.js';
    import { makeUpload } from './save.js';
    import { howManyBotActions } from './bot.js';


    import { createEventDispatcher } from 'svelte';
    import { inflate } from 'pako';
    import { getSuitColor } from './newcards/helpers';
    import { rollbackMessages } from './anydb';
    import { deleteLiveGame, keepMyState, refreshSync, retrySync, unsubFromUpdates, useServerState } from './sb';
    import { perfCount } from './perf.js';

	const dispatch = createEventDispatcher();
    afterUpdate(() => perfCount('render.STGame.afterUpdate'));

    $ui.endGame = async () => {
        $state.endDate = Date.now();
        if(!$state.gameEndTrigger) $state.gameEndTrigger = 'player override'
        if($state.hostUsername == $prefs.username){
            deleteLiveGame(); // only host does this
        }
        unsubFromUpdates(); // unsubscribeDB() here re-fetched a row deleteLiveGame had just deleted
        await scoreGame(true); // before the scoring screen, or it shows a half-built breakdown
        dispatch('end')
    };
    $ui.backToSetup = () => {dispatch('setup')};

    // Ending the game was the only route that dropped the subscription. Leaving by
    // any other means left it live, and a later game then received this one's
    // updates.
    onDestroy(() => {
        unsubFromUpdates();
    });
    

    let currentLog;

    $: if(!isMe($state.activePlayer) && !$state.ended && currentLog && logSoFar){
        currentLog.scrollTo({top: currentLog.scrollHeight});// = currentLog.scrollHeight;
    }

    $: if($state.ended && $ui.waiting.length > 0 && !$ui.waiting[0].finalMessage){
        console.log($ui.waiting);
        advance();
    }

    //$: console.log("Current player: "+$state.currentPlayer)

    let logSoFar;
    $: logSoFar = getLogForTurn($state, -1);

    /*let handSizes = [];
    $: if($state){
        for(let i = 0; i < $state.players.length; i++){
            let p = $state.players[i];
            handSize(p).then((s) => {
                handSizes[i] = s;
            })
        }
    }*/

    if(isTouchDevice()){
        $prefs.showHover = false;
        //$prefs.cardScale = 0.70;
    }

    async function unload(e){
        // Disconnect stuff here?
    }

    function beforeUnload(e){
        return; // Restore later
        if(numMultiPlayers() > 1){
            console.log(numMultiPlayers())
            e.preventDefault();
            return e.returnValue = 'Multiplayer game in progress. Really quit? (Connections will be lost)'
        }
    }

    let looks = {};

    function toggleView(p, deck){
        if(!$ui.looking.some(l => l.exactDeck == p.decks[deck])){
            looks[deck] = lookAtCards(p.decks[deck], true);
        }else{
            if(looks[deck]) closeLook(looks[deck]);
            delete looks[deck];
        } 
    }

    function toggleRewards(){
        if(!$ui.looking.some(l => l.exactDeck == $state.commons.rewards)){
            looks.rewards = lookAtCards($state.commons.rewards, true);
        }else{
            if(looks.rewards) closeLook(looks.rewards);
            delete looks.rewards;
        }
    }

    function scInfo(){
        return stardateSummary(sdCards()[$state.stardatePlayed]);
    }

    // Every bit of the status bar that isn't a control of its own opens the log: the readouts
    // (Stardate pile, turn/phase, the gaps between them) are all one big log button.
    function barClick(e){
        if(e.target.closest && e.target.closest('button, input, select, a, .barcontrol')) return;
        $ui.showingLog = !$ui.showingLog;
    }

    function resetState(){
        let dbID = $state.dbID;
        let gameID = $state.gameID;
        $state = clone($res.interimState.state);
        if(!$state.dbID) $state.dbID = dbID;
        if(!$state.gameID) $state.gameID = gameID;
        $res.undos = $res.undos.slice(0, $res.interimState.undoLength);
        $res.deltas = $res.deltas.slice(0, $res.interimState.undoLength);
        if($state.gameShared) rollbackMessages('current_games', $state.dbID, $state.gameID, $state.offerCounter);
        updateState(false, false); // Is this the right thing?
    }

    setupShortcuts();
    if(!$res.replaying && !$ui.playing) takeTurns();

    function barColour(state){
        if(state.gameEndTurn != -1) return 'background-color: red;';
        if(state.commons.incidents.length == 2) return 'background-color: orangered;'
        if(state.commons.incidents.length == 1) return 'background-color: darkorange;'
        //if(state.loadedStatus == 'cache') return 'background-color: orange;';
        return '';
    }


</script>
<svelte:window on:unload={unload} on:beforeunload={beforeUnload} />
{#if $phoneLayout}
    <PhoneGame />
{:else}
<div use:hideOnPhone>
<FullPage>
        <div slot="top" class="topbar" style={barColour($state)} on:click={barClick}>
            <div style="flex-wrap: nowrap; white-space: nowrap;">
                <ModalButton style={barColour($state)} name="options">≡ Options</ModalButton>
                <ModalButton style={barColour($state)} name="help">? Help</ModalButton>
                {#if $state.players.some(p => !p.bot)}<ModalButton style={barColour($state)} buttonStyle={$state.advertised ? 'darkblue' : 'grey'} name="network"><span style="font-size: 1.5vmin;">🌐</span> Network</ModalButton>{/if}
            <!--{#if $state.commons.rewards && $state.commons.rewards.length > 0}
                <button class="toolbutton" style="font-size: 2vmin;" on:click={e => {toggleRewards()}}>Rewards</button>
            {/if}-->
                {#if $state.gameShared}
                <!-- indicators - modularise later -->
                    <div class="indicators">
                        <div style="display: flex; align-items: center; color: yellow; {$ui.indicators.input || 'visibility: hidden;'}">
                            <!--<div class="dot" style={$ui.indicators.input ? 'background-color: yellow;' : 'visibility: hidden;'} />-->IN
                        </div>
                        <div style="display: flex; align-items: center; color: lightgreen; {$ui.indicators.output || 'visibility: hidden;'}">
                            <!--<div class="dot" style={$ui.indicators.output ? 'background-color: lightgreen;' : 'visibility: hidden;'} />-->OUT
                        </div>
                        
                    </div>
                    {#if $ui.syncFailed}
                        <button class="syncfailed" title="{$ui.syncFailed.what}: {$ui.syncFailed.message}" on:click={retrySync}>
                            Not saved &mdash; retry
                        </button>
                    {/if}
                    {#if $ui.syncConflict}
                        <span class="syncconflict barcontrol" title="Server v{$ui.syncConflict.incomingVersion}, yours v{$ui.syncConflict.heldVersion}. Someone saved over your last move — open the Network pane for detail.">
                            Overwritten
                            <button on:click={keepMyState}>Keep mine</button>
                            <button on:click={useServerState}>Use theirs</button>
                        </span>
                    {/if}
                    <svg class="barcontrol" on:click={refreshSync} style="display: none; width: 2vmin; height: auto;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M480.1 192l7.9 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2S477.9 .2 471 7L419.3 58.8C375 22.1 318 0 256 0 127 0 20.3 95.4 2.6 219.5 .1 237 12.2 253.2 29.7 255.7s33.7-9.7 36.2-27.1C79.2 135.5 159.3 64 256 64 300.4 64 341.2 79 373.7 104.3L327 151c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 192 344 192l136.1 0zm29.4 100.5c2.5-17.5-9.7-33.7-27.1-36.2s-33.7 9.7-36.2 27.1c-13.3 93-93.4 164.5-190.1 164.5-44.4 0-85.2-15-117.7-40.3L185 361c6.9-6.9 8.9-17.2 5.2-26.2S177.7 320 168 320L24 320c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8C137 489.9 194 512 256 512 385 512 491.7 416.6 509.4 292.5z"/></svg>
                {/if}
            </div>
            <div class="textgroup"> 
                <!--{#if $prefs.stardates}-->
                    {#if sdCards($state, $res).length > $state.stardatePlayed} 
                        {#if scInfo($state)}
                            <!-- .barcontrol keeps barClick's hands off it: the readout opens the editor,
                                 the text around it opens the log -->
                            {scInfo($state)} in <span class="barcontrol" on:click={e => editStardate()}><TokenDisplay display={stardateGlory($state.stardatePlayed) - $state.gloryTaken} name="glory" size={4} /></span>
                        {/if}
                        ({$state.stardatePlayed + 1}/{sdCards($res, $state).length})
                    {:else}
                        <!-- Clickable with the pile empty too: that state is the only way to trigger
                             and untrigger the end of the game -->
                        <span class="barcontrol" on:click={e => editStardate()}>Glory pile empty</span>
                    {/if}
                <!--{:else}
                    Glory pile: <TokenDisplay display={$state.glory} name="glory" size={4} />
                {/if}-->
            </div>
            <div style="overflow-x: auto; white-space: nowrap;">
                Turn {$state.turn}, player {$state.currentPlayer + 1} ({$state.players[$state.currentPlayer].captain})
                    {#if $state.phase}
                        , {$state.phase} phase
                    {:else}
                        : handing over
                    {/if}
                {#if $state.gameEndTurn != -1}
                    (ending turn {$state.gameEndTurn}!)
                {/if}
            </div>
            <!--&& $ui.seats.filter(s => s.id == $ui.peerID).length-->
            <!-- Seats taken out for now, can reinstate if need be 29 Jan 2025-->
            <!--{#if !$state.practice && !$prefs.bothSeats && $state.players.filter(p => p.username == $prefs.username).length > 1}
                <div class="textgroup"> 
                    Seat: 
                    {#each $ui.seats as pl, p}
                        <button class="toolbutton" style={p == $ui.seat ? 'color: darkblue; background-color: white;' : '' } disabled={p == $ui.seat} on:click={ (e) => {changeSeat(p); } }>{$state.players[p].captain}</button>
                    {/each}
                </div>
            {/if}-->
            {#if !$state.practice && !$prefs.showBoth}
                <div class="textgroup"> 
                    View: 
                    {#each $state.players as pl, p}
                        <button class="toolbutton" style={p == $ui.viewing ? 'color: darkblue; background-color: white;' : '' } disabled={p == $ui.viewing} on:click={ (e) => {changeView(p);} }>
                            {#if !isMe(p, $ui, $state)}
                                <span style="font-size: 1.5vmin;">🌐</span> 
                            {/if}
                                {pl.captain}
                        </button>
                    {/each}
                </div>
            {/if}
            <div class="barcontrol" on:click={e => { $prefs.showSize = !$prefs.showSize; makeUpload($state) }}>
                {#if $ui.saved}Saved{:else}Unsaved{/if}{#if $prefs.showSize} ({formatBytes(JSON.stringify($state).length)}) {/if}
            </div>
            {#if isMe(currentPlayer($state)) && isMe(activePlayer($state)) && !$ui.waiting.some(w => !w.turnMarker)}
             <button class="toolbutton" on:click={resetState}>Restart phase</button>
            {/if}
        </div>
        <div slot="main" style="height: 100%; ">
            <!--<CardGen facedown c={$state.commons.market[0]} />-->
            <table class="market">
                <tr>
                    {#if $prefs.separateMarkets}
                        <td class="market_item" style="background-color: {getSuitColor('person')}" on:click={e => { doAction($state.players[$state.activePlayer], 'scan', {deck: $state.commons.people})}}>
                            {@html convert('[[person]]')} People<!-- : {$state.commons.people.length}  -->
                        </td>  
                        <td class="market_item" style="background-color: {getSuitColor('cargo')}" on:click={e => { doAction($state.players[$state.activePlayer], 'scan', {deck: $state.commons.cargo})}}>
                            {@html convert('[[cargo]]')} Cargo<!-- : {$state.commons.cargo.length}  -->
                        </td>  
                        <td class="market_item" style="background-color: {getSuitColor('ship')}" on:click={e => { doAction($state.players[$state.activePlayer], 'scan', {deck: $state.commons.ships})}}>
                            {@html convert('[[ship]]')} Ships<!-- : {$state.commons.ships.length}  -->
                        </td>  
                        <td class="market_item" style="background-color: {getSuitColor('ally')}" on:click={e => { doAction($state.players[$state.activePlayer], 'scan', {deck: $state.commons.allies})}}> <!-- TODO make it me!-->
                            {@html convert('[[ally]]')} Allies<!--: {$state.commons.allies.length} -->
                        </td>  
                    {:else}
                        <td colspan="4" class="market_item">
                            {@html convert('[[ally]] [[ship]] [[cargo]] [[person]]')} Market: {$state.commons.market.length} 
                        </td>
                    {/if}
                    <td colspan={$res.cardsInNeutralZone + ($state.commons.neutral_zone[$res.cardsInNeutralZone] && isBadlands($state.commons.neutral_zone[$res.cardsInNeutralZone]) ? 1 : 0)} class="market_item" style="background-color: {getSuitColor('location')}" on:click={e => { if($state.commons.locations.length > 0) look($state.commons.locations[0]); }}>
                        {@html convert('[[location]]')} Neutral zone ({$state.commons.locations.length} left in deck)
                    </td>
                    <td class="market_item" style="background-color: {getSuitColor('encounter')}">
                        {@html convert('[[encounter]]')} Encounters<!-- : {$state.commons.encounters.length} -->
                    </td>
                    <!--<td class="market_item">
                        {@html convert('[[mission]]')} Missions
                    </td>-->
                    <td class="market_item" style="background-color: {getSuitColor('incident')}">
                        {@html convert('[[incident]]')} Incidents<!-- : {$state.commons.incidents.length} -->
                    </td>
                    <!--<td class="market_item">
                        {@html convert('[[person]]')} Redshirts
                    </td>-->
                    <!--{#if $state.commons.badlands}
                        <td  class="market_item">
                           🔥 Badlands
                        </td>
                    {/if}-->
                    {#if $state.commons.rewards}
                        <td class="market_item">
                            🎖️ Rewards
                        </td>
                    {/if}
                    <td class="market_item" on:click={e => lookAtCards($state.commons.destroyed.filter(c => c.left && c.left.location == 'destroyed'), true)}>
                       🗑️ Junk<!-- : {$state.commons.junk.length} -->
                    </td>
                </tr>
                <tr>
                    {#if $prefs.separateMarkets}
                        <td><Card deck={$state.commons.people} c={$state.commons.people[0]} /></td>
                        <td><Card deck={$state.commons.cargo} c={$state.commons.cargo[0]} /></td>
                        <td><Card deck={$state.commons.ships} c={$state.commons.ships[0]} /></td>
                        <td><Card deck={$state.commons.allies} c={$state.commons.allies[0]}/></td>
                    {:else}
                        <td><Card deck={$state.commons.market_zone} c={$state.commons.market_zone[0]}/></td>
                        <td><Card deck={$state.commons.market_zone} c={$state.commons.market_zone[1]} index={1} /></td>
                        <td><Card deck={$state.commons.market_zone} c={$state.commons.market_zone[2]} index={2} /></td>
                        <td><Card deck={$state.commons.market_zone} c={$state.commons.market_zone[3]} index={3} /></td>
                    {/if}
                    {#each Array($res.cardsInNeutralZone) as _, i}
                        <td>
                            <Card single bind:deck={$state.commons.neutral_zone} c={$state.commons.neutral_zone[i]} index={i} />
                        </td>
                    {/each}
                    {#if $state.commons.neutral_zone[$res.cardsInNeutralZone] && isBadlands($state.commons.neutral_zone[$res.cardsInNeutralZone])}
                        <td>
                            <Card single bind:deck={$state.commons.neutral_zone} c={$state.commons.neutral_zone[$res.cardsInNeutralZone]} index={$res.cardsInNeutralZone} />
                        </td>
                    {/if}
                    <td><Card facedown c={$state.commons.encounters[0]} bind:deck={$state.commons.encounters} /></td>
                    <!--<td><Card facedown c={$state.commons.missions[0]} bind:deck={$state.commons.missions} /></td>-->
                    <td><Card facedown c={$state.commons.incidents[0]} bind:deck={$state.commons.incidents} /></td>
                    <!--<td><Card c={$state.commons.redshirts[0]} bind:deck={$state.commons.redshirts} /></td>-->
                    <!--{#if $state.commons.badlands}
                        <td>
                            <Card single bind:deck={$state.commons.badlands} c={$state.commons.badlands[0]} index={0} />
                        </td>
                    {/if}-->
                    {#if $state.commons.rewards}
                        <td><Card c={$state.commons.rewards[0]} bind:deck={$state.commons.rewards} /></td>
                    {/if}
                    <td><Card c={$state.commons.junk[0]} bind:deck={$state.commons.junk} /></td>
                </tr>
            </table>
            <div class="players">
                <!--{#each $state.players as p, i}-->
                        <PlayerView />
                <!--{/each}
                <!--<Card facedown bind:deck={$state.players[0].decks.reserve} />
                    <Card facedown bind:deck={$state.players[0].decks.deck} />
                    <Card deck={$state.players[0].decks.discard} />
                    {#each $state.players[0].decks.hand as c, index}
                        <Card bind:deck={$state.players[0].decks.hand} {c} {index}/>
                    {/each}--> 
            </div>
        
        </div>
        <div slot="bottom">
            {#each $state.players.filter((p,i) => i == $ui.viewing) as p, i}
                <div class="textgroup">
                    <div class="tokens" style="margin-left: {$prefs.buttonMargin}px; ">
                        {#each playerResourceTypes(p) as r}
                            {#if r != 'activations' || $prefs.numActivations != -1}
                                {#if r == 'actions' && p.bot}
                                    <TokenDisplay name="actions" display={howManyBotActions(p, $state)} size={4}/>
                                {:else}
                                    {#if !p.bot || r == 'glory' || r == 'dilithium' || p[r]}
                                        <TokenEdit {p} {r} size={4} />
                                    {/if}
                                {/if}
                            {/if}
                        {/each} 
                        {#if !p.bot}
                            {#each $res.playerVariableTypes as r}
                                <TokenDisplay name={r.name} display={p[r.var]} size={4} />
                            {/each} 
                        {/if}
                        {#if $state.campaign && i == 0 && p.decks.reinforcements.length > 0}
                            <button class="toolbutton" style="font-size: 2vmin;" on:click={e => {toggleView(p, 'reinforcements')}}>Reinforcements ({p.decks.reinforcements.length})</button>
                        {/if}
                        {#if p.decks.crossover}
                            <button class="toolbutton" style="font-size: 2vmin;" on:click={e => {toggleView(p, 'crossover')}}>Crossover ({p.decks.crossover.length})</button>
                        {/if}
                    </div>
                </div>
            {/each}
            <Prompt />
            {#if !$state.practice}
                {#each $state.players.filter((p,i) => i != $ui.viewing) as p}
                    <div class="textgroup">
                        {p.captain}:
                        <div class="tokens" style="margin-left: {$prefs.buttonMargin}px; ">
                            {#each playerResourceTypes(p) as r}
                                {#if r != 'activations' || $prefs.numActivations != -1}
                                    {#if r == 'actions' && p.bot}
                                        <TokenDisplay name="actions" display={howManyBotActions(p, $state)} size={4} />
                                    {:else}
                                        {#if !p.bot || r == 'glory' || r == 'dilithium' || p.captain == 'Q' && r == 'whim'}
                                            <TokenEdit {p} {r} size={4} />
                                        {/if}
                                    {/if}
                                {/if}
                            {/each} 
                        </div>
                    </div>
                {/each}
            {:else}
                <div class="textgroup">&nbsp;</div>
            {/if}
        </div>
        
    </FullPage>
</div>
{/if}
    <Preview />
    {#each $ui.looking as l, i (i)}
        <DeckLook bind:this={l.component} bind:deck={l.deck} {...l} on:close={e => { $ui.looking = [...$ui.looking.slice(0, i), ...$ui.looking.slice(i+1)]; if(l.component) try { l.component.$destroy(); }catch(e){console.log("Error destroying look component", e);} }} on:close_shuffle={e => { $ui.looking = [...$ui.looking.slice(0, i), ...$ui.looking.slice(i+1)]; if(l.component) if(l.component) try { l.component.$destroy(); }catch(e){console.log("Error destroying look component", e);};  shuffle(getDeck($state, l.area, l.deck, l.player)) }}/>
    {/each}
    {#each Object.keys($ui).filter(k => k.startsWith('showing') && $ui[k]) as k}
        <Modal name={k.slice('showing'.length)} />
    {/each}
    {#if $ui.announcement}
        <div in:fade|global="{{ duration: 200 }}" out:fade|global="{{ duration: 1000 }}" class="announcement">{$ui.announcement}</div>
    {/if}
<style>
    /* Neither of these used to exist: a send that never landed, and a stale write
       that landed on top of yours, both passed in complete silence. */
    .syncconflict {
        display: inline-flex;
        align-items: center;
        gap: 0.5vmin;
        background-color: #8A5A00;
        color: white;
        border-radius: 0.6vmin;
        padding: 0.3vmin 0.8vmin;
        font-size: 1.4vmin;
        font-weight: bold;
        white-space: nowrap;
    }

    .syncconflict button {
        font-size: 1.3vmin;
        border: none;
        border-radius: 0.4vmin;
        padding: 0.2vmin 0.6vmin;
        cursor: pointer;
    }

    .syncfailed {
        background-color: #A32B21;
        color: white;
        border: none;
        border-radius: 0.6vmin;
        padding: 0.3vmin 0.8vmin;
        font-size: 1.4vmin;
        font-weight: bold;
        cursor: pointer;
        white-space: nowrap;
    }

   .main {
        width: 100vw;
        height: 100vh;
    }
    .cardlist {
        display: flex;
        flex-wrap: wrap;
    }


    .toolbutton {
        font-weight: bold;
        border: 2px solid white;
        padding: 0.25vmin;
        color: white;
        background-color: darkblue;
        margin: 0;
        border-radius: 0;
    }

    /* The whole bar is a log button, so it reads as clickable; cursor inherits into the
       controls sitting on it, which are clickable too. */
    .topbar {
        cursor: pointer;
    }

    .textgroup {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        white-space: nowrap;
        margin-right: 10px;
    }


    .market {
        position: absolute;
        top: 0;
        width: 100%;
    }
    
    .market_item {
        font-size: 0.8em;
        text-align: center;
        background-color: grey;
        border: 3px solid white;
        font-weight: bold;
        cursor: pointer;
    }

    .players {
        position: absolute;
        width: 100vw;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        grid-template-columns: min-content 1fr min-content; /*35vw 40vw 25vw;*/
        align-items: end;
        pointer-events: none; /* TODO remember that this prevents other clicks except within areas! */
    }


    .tokens {
        display: flex;
        justify-items: center;
    }


    .modal {
		position: absolute;
		z-index: 200;
		/*left: 50%;
		top: 50%;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
		max-height: 90vh;
        height: fit-content;
        width: fit-content;
		max-width: 90vw;
		min-width: 60vw;
		overflow: auto;
		background-color: grey;
		color: black;
		box-shadow: 0 0 5px 5px black; color: white;
	}

    button {
		border-radius: 1vmin; 
        color: white;
		background: rgba(150,150,150,0.5);
		filter: drop-shadow(0.5vmin 0.5vmin 0.5vmin slategray);
	}

    button:disabled { 
        color: gray;
        background: rgba(0,0,0,0.5);
    }

    :global(.ok) {
        background: rgba(0,255,0,0.5);
    }

    :global(.cancel) {
        background: rgba(255,0,0,0.5);
    }


    
    
    .current_log {
        position: fixed;
        z-index: 300;
		left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
        height: fit-content;
        width: fit-content;
		max-height: 20vh;
		max-width: 90vw;
		min-width: 60vw;
		overflow: auto;
		background-color: grey;
		color: black;
		box-shadow: 0 0 5px 5px black; color: white;
        display: block;
    }

    
    
    .announcement {
        font-size: 10vmin;
        pointer-events: none;
        font-weight: bold;
        color: white;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(5px);
        margin: auto;
        height: fit-content;
        width: fit-content;
        text-align: center;
        padding: 4vmin;
        border-radius: 2vmin;
        position: fixed;
        top: 0;
        bottom: 40vmin;
        left: 0;
        right: 0;
        z-index: 99999;
    }
    
    .indicators {
        display: inline-flex;
        flex-direction: column;
        height: 2vmin;
        font-size: 0.75em;
        /* margin: -10%; */
        /* padding: 0; */
        position: absolute;
        padding-left: 0.5vmin;
        /* align-self: flex-start; */
        /* align-items: center; */
    }

    .dot {
        height: 1vmin;
        width: 1vmin;
        background-color: white;
        border-radius: 50%;
        display: inline-block;
    }

    :global(html, body) {
        overscroll-behavior: contain;
    }
</style>
